import { render } from "./Result5D.vue?vue&type=template&id=04dce05c"
import script from "./Result5D.vue?vue&type=script&lang=js"
export * from "./Result5D.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__